module.exports = {
      id: "heart-usage",
      viewBox: "0 0 21.4 19.2",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#heart-usage",
      toString: function () {
        return this.url;
      }
    }